import type { RemoteConfig, FeatureFlags } from '@funtech-int/yango-shared';
import { LegacyTvChannelPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { ProfileManager } from '@/shared/lib/profileManager';

import { TelemetryContentPlace, TelemetryContentType } from '../../Player/types';
import { getEmptyPreferredTracks } from '../../feature-player/utils/config/get-empty-preferred-tracks';
import { getOnlineStreamsConfig } from '../../feature-player/utils/config/get-online-streams-config';

import { getChannelContentId } from './get-channel-content-id';
import { getChannelOnlineStreams } from './get-channel-online-streams';

interface Dependencies {
    profileManager: ProfileManager;
    featureFlags: FeatureFlags;
    remoteConfig: RemoteConfig;
}

interface Props {
    telemetryContentPlace: TelemetryContentPlace;
}

export const getChannelPlayerConfig = (
    channel: LegacyTvChannelPlayerBaseInfoContent,
    { telemetryContentPlace }: Props,
    deps: Dependencies
) =>
    getOnlineStreamsConfig(
        {
            contentId: getChannelContentId(channel),
            telemetry: {
                from_block: telemetryContentPlace,
                stream_block: TelemetryContentType.Channel,
            },
            onlineStreams: getChannelOnlineStreams(channel),
            preferredTracks: getEmptyPreferredTracks(),
            fetchSubtitles: true,
        },
        deps
    );
